import { render, staticRenderFns } from "./BuildRoster.vue?vue&type=template&id=61b03c4d&scoped=true&"
import script from "./BuildRoster.vue?vue&type=script&lang=js&"
export * from "./BuildRoster.vue?vue&type=script&lang=js&"
import style0 from "./BuildRoster.vue?vue&type=style&index=0&id=61b03c4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b03c4d",
  null
  
)

export default component.exports